//import { Carousel } from "react-responsive-carousel";
//import "react-responsive-carousel/lib/styles/carousel.min.css";
//import ProposeSVG from "../assets/svg/what/propose";
//import QuerySVG from "../assets/svg/what/query";
//import RedactSVG from "../assets/svg/what/redact";
//import VisualizeSVG from "../assets/svg/what/visualize";
import { useInView } from "react-intersection-observer";
import what from '../assets/images/what.png';

const What = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '-100px 0px',
  });

  return (
    <div className="h-screen bg-cover overflow-hidden the_what_section_css">
      <div className="hidden md:block h-screen">
        <div ref={ref} className="max-w-[1200px] h-full w-full mx-auto flex items-center justify-around">
          <img src={what} alt=""   className="max-h-240-mobile-touch max-h-600-desktop-pointer"/>
        </div>
      </div>
      <div className="md:hidden flex justify-center items-center h-screen">
        <img src={what} alt="" />
      </div>
    </div>
  );
};

export default What;
